// Waga, którą księga zapłaciła za mecz. `null` to wiersz sprzed zapisywania wagi —
// piszemy „—", bo „nie wiadomo" to inna odpowiedź niż „liczyło się normalnie".
export function ratingMultiplierLabel(multiplier: number | null | undefined): string {
  if (multiplier === null || multiplier === undefined) {
    return "—";
  }

  return `×${multiplier.toLocaleString("pl-PL", { maximumFractionDigits: 2 })}`;
}

// Zwykły mecz waży 1 — kolumna ma wyróżniać te, które liczyły się inaczej.
export function isReducedOrBoosted(multiplier: number | null | undefined): boolean {
  return multiplier !== null && multiplier !== undefined && multiplier !== 1;
}
